/**
 * Money Formatting Utils
 */

import { formatMoney } from 'accounting';

export enum Currency {
  CAD = 'CAD',
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  AUD = 'AUD',
  NZD = 'NZD',
}

export function getFormattedMoney(amount: number, currency: GQL.Currency, precision = 0) {
  return formatMoney(amount, { precision, symbol: currency + ' ' });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/money.ts